var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimerStart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5195_188903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4068 4.87533H8.5901C8.25677 4.87533 7.9901 4.60866 7.9901 4.27533C7.9901 3.94199 8.25677 3.66699 8.5901 3.66699H13.4068C13.7401 3.66699 14.0068 3.93366 14.0068 4.26699C14.0068 4.60033 13.7401 4.87533 13.4068 4.87533Z",
    fill: "url(#paint0_linear_5195_188903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6401 14.5003H15.1901C14.1318 14.5003 13.4984 15.1337 13.4984 16.192V18.642C13.4984 19.7003 14.1318 20.3337 15.1901 20.3337H17.6401C18.6984 20.3337 19.3318 19.7003 19.3318 18.642V16.192C19.3318 15.1337 18.6984 14.5003 17.6401 14.5003ZM17.4068 18.217L16.4234 18.7837C16.2234 18.9003 16.0234 18.9587 15.8401 18.9587C15.6984 18.9587 15.5734 18.9253 15.4568 18.8587C15.1901 18.7003 15.0401 18.392 15.0401 17.9837V16.8503C15.0401 16.442 15.1901 16.1337 15.4568 15.9753C15.7234 15.817 16.0651 15.8503 16.4234 16.0503L17.4068 16.617C17.7568 16.8253 17.9568 17.1087 17.9568 17.417C17.9568 17.7253 17.7651 18.0087 17.4068 18.217Z",
    fill: "url(#paint1_linear_5195_188903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6651 18.642V16.192C12.6651 14.6837 13.6818 13.667 15.1901 13.667H17.6401C17.8318 13.667 18.0151 13.6837 18.1901 13.717C18.2068 13.517 18.2234 13.317 18.2234 13.1087C18.2234 9.11699 14.9818 5.87533 10.9984 5.87533C7.0151 5.87533 3.77344 9.11699 3.77344 13.1087C3.77344 17.092 7.0151 20.3337 10.9984 20.3337C11.7068 20.3337 12.3818 20.217 13.0318 20.0337C12.7984 19.642 12.6651 19.1753 12.6651 18.642ZM11.6234 12.8337C11.6234 13.1753 11.3401 13.4587 10.9984 13.4587C10.6568 13.4587 10.3734 13.1753 10.3734 12.8337V8.66699C10.3734 8.32533 10.6568 8.04199 10.9984 8.04199C11.3401 8.04199 11.6234 8.32533 11.6234 8.66699V12.8337Z",
    fill: "url(#paint2_linear_5195_188903)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5195_188903",
    x: 0.440104,
    y: 0.333659,
    width: 22.2253,
    height: 23.3337,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.335543 0 0 0 0 0.326939 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5195_188903"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5195_188903",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5195_188903",
    x1: 11.5526,
    y1: 3.66699,
    x2: 11.5526,
    y2: 20.3337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5195_188903",
    x1: 11.5526,
    y1: 3.66699,
    x2: 11.5526,
    y2: 20.3337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5195_188903",
    x1: 11.5526,
    y1: 3.66699,
    x2: 11.5526,
    y2: 20.3337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DC00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerStart);
export default __webpack_public_path__ + "static/media/timer-start.d0b68676004479d80deb5dddb51a1cb8.svg";
export { ForwardRef as ReactComponent };